import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../App/redux/store';
import { APIStatus } from '../../../services/axiosEnums';
import { modalsActions } from '../../modals/modalsSlice';
import { adActions } from '../adSlice';
import fetchAdThunk from '../services/thunks/fetchAdThunk';

interface IUseActiveAdProps {
  adIdIri: string | null;
}

function useActiveAd({ adIdIri }: IUseActiveAdProps) {
  const dispatch = useAppDispatch();
  const { apiStatus, result, error } = useAppSelector(
    (state) => state.ad.activeAd,
    shallowEqual,
  );

  useEffect(() => {
    return () => {
      // remove active ads and ad plots from store
      dispatch(adActions.activeAdReset());
    };
  }, []);

  useEffect(() => {
    if (apiStatus === APIStatus.IDLE && !result && adIdIri) {
      dispatch(fetchAdThunk({ idIri: adIdIri }));
    }
  }, [apiStatus, result, adIdIri]);

  const createStudyFromAd = () => {
    dispatch(
      modalsActions.chooseFolder({ action: 'CREATE', currentFolderIdIri: null }),
    );
  };

  const deleteAds = (value: boolean) => {
    dispatch(modalsActions.deleteAds(value));
    if (!value) {
      dispatch(adActions.selectedAdsReset());
    }
  };

  return { deleteAds, createStudyFromAd, apiStatus, ad: result, error };
}

export default useActiveAd;
